import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AppButton from '../components/buttons/AppButton';
import MainView from '../components/views/MainView';
import { userInfo } from '../redux/actions/stravnik';
import { Update, Restaurant, AssignmentOutlined } from '@mui/icons-material';
  
const InfoScreen = () => {
  
    const dispatch = useDispatch()
    let {activeAccount} = useSelector(mapStateToProps)
    const navigate = useNavigate();

    const { t } = useTranslation();

    useEffect(() => {
        dispatch(userInfo())
    }, [activeAccount]);

    let showTextJidelnicek = (activeAccount && activeAccount.user && activeAccount.zarizeni && activeAccount.zarizeni.jidelnicek)

    return (
      <MainView loggedOnly={true}>
          <div className="baseMarginView" data-testid="info-page">
            <h2 className="wizard_header">{t('info.header')} </h2>

            <div className="basePaddingView">
              <AppButton onPress={() => navigate("/jidelnicek-vypis")} testId="static-menu-link" label={t('info.buttons.staticVersion')} style={{marginRight: 5}}>
                <Restaurant fontSize="small" style={{marginRight: 4}}/>
            </AppButton>

            <AppButton onPress={() => navigate("/casove-omezeni")} testId="deadlines-link" label={t('info.buttons.deadlines')} style={{marginRight: 5}}>
              <Update fontSize="small" style={{marginRight: 4}}/>
            </AppButton>

            {showTextJidelnicek != "" && showTextJidelnicek &&
            <AppButton onPress={() => navigate("/jidelnicek-text")} testId="text-menu-link" label={t('info.buttons.textVersion')} style={{marginRight: 5}}>
              <AssignmentOutlined fontSize="small" style={{marginRight: 4}}/>
            </AppButton>}

            </div>

            {activeAccount && activeAccount.zarizeni && <>
              <p className="wizard_text basePaddingView" style={{ whiteSpace: "pre-wrap"}}>
                {activeAccount.zarizeni.info}
              </p>
            </>}
        </div>
      </MainView>
    )
  
}

const mapStateToProps = (state) => {
  return {
      activeAccount: state.auth.actualAccount > -1 ? state.auth.accounts[state.auth.actualAccount] : null
  }
}

export default InfoScreen
